module.exports = __webpack_public_path__ + "img/logo56.429ba0c9.png";